import _ from "lodash";
import React from "react";
import classes from "./RelatedConceptItem.scss";
import { SelectDropdown } from "@toddle-edu/ds-web";
import UILabel from "UIComponents/UILabel";
import { useI18n } from "Hooks";

const RelatedConceptItem = ({
  value,
  options,
  updateInputField,
  label,
  isArchived,
  updateGroupedState,
  testId,
}) => {
  const { t } = useI18n(["common", "unitPlan"]);
  const labelText = isArchived ? `${label} (${t("common:archived")})` : label;
  const onCreateOptionOnChange = val => {
    updateGroupedState({ value: val, label: val });
  };
  return (
    <div className={classes.container}>
      <UILabel label={labelText}></UILabel>
      <SelectDropdown
        isMulti={true}
        size={"large"}
        value={value}
        options={options}
        onChange={updateInputField}
        placeholder={t("unitPlan:relatedConcept_dropdown_emptyText")}
        isClearable={true}
        isCreatable={true}
        onCreateOption={onCreateOptionOnChange}
        testId={`${testId}-${_.camelCase(label)}`}
      />
    </div>
  );
};

export default RelatedConceptItem;
